import { TextField, Button, outlinedInputClasses, Grid, Icon, Stack, Chip, CircularProgress, Box } from "@mui/material";
import { styled } from "@mui/styles";
import { Check, Close, LocalOffer } from "@mui/icons-material";

function PromoPumaTextField({ discount, handleChange, handleSubmit, loading, error, appliedDiscounts, handleRemoveDiscount }) {
  return (
    <Box sx={{ width: "100%" }}>
      <form onSubmit={handleSubmit} style={{ marginBottom: 0 }}>
        <Grid container spacing={1}>
          <Grid item xs>
            <Box sx={{ px: 1, border: 1, borderRadius: 1, borderColor: "#757575" }}>
              <Stack direction="row" alignItems="center" spacing={1}>
                {loading ? <CircularProgress size={20} /> : <LocalOffer style={{ color: "#757575" }} />}

                {appliedDiscounts
                  ?.filter(d => !d.hidden)
                  .map(d => {
                    const color = true;
                    return (
                      <Chip
                        key={d.name}
                        variant="outlined"
                        label={d.name}
                        avatar={<Icon>{<Check sx={{ color: "green" }} />}</Icon>}
                        deleteIcon={<Close />}
                        sx={{ justifyContent: "space-between", px: 1, borderColor: color, color }}
                        onDelete={handleRemoveDiscount(d)}
                      />
                    );
                  })}

                <ClearTextField
                  fullWidth
                  placeholder={"Promo Code..."}
                  size="small"
                  variant="outlined"
                  disabled={!!appliedDiscounts?.filter(d => !d.hidden).length || loading}
                  value={appliedDiscounts?.filter(d => !d.hidden).length ? " " : discount}
                  error={!!error}
                  onFocus={e => null}
                  onChange={handleChange}
                />
              </Stack>
            </Box>
          </Grid>
          <Grid item>
            <Button disableElevation disabled={loading || !discount} onClick={handleSubmit}>
              Apply
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}

export default PromoPumaTextField;

const ClearTextField = styled(TextField)({
  [`& .${outlinedInputClasses.root} .${outlinedInputClasses.input}`]: {
    marginBottom: 0,
    // fontSize: 20,
    border: 0,
  },
  [`& .${outlinedInputClasses.root}`]: {
    [`&.${outlinedInputClasses.focused} fieldset`]: {
      // fontSize: 20,
      border: 0,
    },
  },
  [`& .${outlinedInputClasses.notchedOutline}`]: {
    borderWidth: 0,
  },
  [`& .MuiInputBase-root`]: {
    paddingRight: 0,
  },
});
